export var initialSendProductValues = {
    talentPubId: '',
    talentAddressPubId: '',
    jobPubId: '',
    courierPubId: '',
    details: [],
    products: [],
    note: '',
};
export var SendProductValues = {
    talent: {
        pubId: '',
    },
    job: {
        pubId: '',
    },
    address: {
        pubId: '',
    },
    courier: {
        pubId: '',
    },
    details: [
        {
            product: {
                pubId: '',
                name: '',
                productCategory: {
                    pubId: '',
                    name: '',
                },
            },
            qty: 1,
        },
    ],
    note: '',
    products: [
        {
            productPubId: '',
            productCategoryPubId: '',
            qty: 1,
        },
    ],
};
export var initialSendProductNonTalentValues = {
    recipientName: '',
    phoneNumber: '',
    address: '',
    cityPubId: '',
    courierPubId: '',
    sendProduct: {
        products: [
            {
                productPubId: '',
                qty: 1,
                productCategoryPubId: '',
            },
        ],
    },
    note: '',
    proofTransferFilePubId: '',
    details: [],
};
